import React, { useRef, useLayoutEffect } from 'react';
import { createPortal } from 'react-dom';
import FocusLock from 'react-focus-lock';

export const ModalPortal = ({ children }) => {
  const modalRoot = useRef(document.createElement('div'));

  useLayoutEffect(() => {
    const root = modalRoot.current;
    document.body && document.body.appendChild(root);

    return () => root.remove();
  }, []);

  return createPortal(<FocusLock>{children}</FocusLock>, modalRoot.current);
};



// WEBPACK FOOTER //
// ./src/components/Modal/ModalPortal.js